import React from 'react';
import SEO from '../components/SEO';
import './AboutPage.css';
import image1 from '../images/image-1.jpeg';
import image2 from '../images/image-2.jpeg';
import image3 from '../images/image-3.jpeg';
import image4 from '../images/rinku.jpeg';
import certificateImage from '../images/certificate.jpeg';
import shubhamImage from '../images/shubham.jpeg';
import mohitImage from '../images/mohit.png';
import rinkuImage from '../images/rinku.jpeg';
import ankitImage from '../images/ankit.png';

function AboutPage() {
  const advocatesTop = [
    {
      image: image1,
      name: 'अधिवक्ता शाकिर सिद्दीकी',
      title: 'हाईकोर्ट'
    },
    {
      image: image2,
      name: 'सचिन कुमार एडवोकेट',
      title: 'हाई कोर्ट इलाहाबाद, विधि सलाहकार RR NEWS TV FASTEST UPDATE'
    },
    {
      image: image3,
      name: 'एडवोकेट प्रिया चौधरी',
      title: 'सर्वोच्च न्यायालय नई दिल्ली'
    }
  ];

  const advocatesBottom = [
    {
      name: 'एडवोकेट डीके चौधरी',
      title: 'डिस्ट्रिक्ट कोर्ट मुरादाबाद'
    },
    {
      name: 'एडवोकेट उमा सिंह',
      title: 'डिस्ट्रिक्ट कोर्ट मुरादाबाद'
    },
    {
      name: 'अधिवक्ता प्रीति चौधरी',
      title: 'संस्थापक – RR NEWS TV FASTEST UPDATE'
    }
  ];

  const editors = [
    {
      image: shubhamImage,
      name: 'शुभम चंद्रवंशी',
      title: 'आई.टी. हेड, RR NEWS TV FASTEST UPDATE'
    },
    {
      image: rinkuImage,
      name: 'रिंकू चौधरी',
      title: 'वरिष्ठ पत्रकार, RR NEWS TV FASTEST UPDATE'
    },
    {
      image: ankitImage,
      name: 'अंकित सैनी',
      title: 'आई.टी. विभाग, RR NEWS TV FASTEST UPDATE'
    }
  ];

  return (
  <>
    {/* SEO Meta Tags */}
    <SEO
      title="हमारे बारे में - RR NEWS TV FASTEST UPDATE"
      description="RR NEWS TV FASTEST UPDATE - देश-विदेश की ताज़ा, भरोसेमंद खबरों का डिजिटल समाचार पोर्टल। जानें हमारे बारे में और हमारी टीम के बारे में।"
      keywords="RR NEWS TV FASTEST UPDATE, about us, हमारे बारे में, rr news team, hindi news"
      url="/about"
      type="website"
    />
    
  <main id="content-start" className="about-page container">
      <header className="about-hero reveal">
        <h1 className="about-title">RR NEWS TV FASTEST UPDATE — हमारे बारे में</h1>
        <p className="about-sub">RR NEWS TV FASTEST UPDATE में आपका स्वागत है। हमारा उद्देश्य सच्ची, समयोचित, निष्पक्ष और ज़मीनी खबरों को समाज के हर वर्ग तक पहुँचाना है। हम केवल समाचार प्रसारित करने वाला प्लेटफ़ॉर्म नहीं, बल्कि जनता की आवाज़ को जिम्मेदार प्रशासन और सरकार तक पहुँचाने का एक सशक्त माध्यम बनने के लिए प्रतिबद्ध हैं।</p>
      </header>

      <section className="about-section reveal card">
        <h2 className="section-heading">हमारा उद्देश्य</h2>
        <p>
          हमारा मुख्य उद्देश्य है—सच्ची, समयोचित और ज़मीनी खबरें पहुँचाना, ताकि जनता जागरूक हो, स्थानीय मुद्दों पर सार्थक विमर्श हो और समाज के प्रत्येक वर्ग को अपनी बात रखने का मंच मिले।

हम छोटे-बड़े सभी स्थानीय मुद्दों को समान महत्व देते हैं और ऐसी पत्रकारिता को बढ़ावा देते हैं जो समाज में पारदर्शिता, जवाबदेही और सकारात्मक बदलाव लाने में सहायक हो।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">1. शहीद सम्मान अभियान — राष्ट्र के वीरों को नमन</h2>
        <p>
          देश के वीर शहीदों के बलिदान को सम्मान देना हमारे प्रमुख उद्देश्यों में शामिल है। इसी भावना के तहत हम प्रत्येक माह देश के एक वीर शहीद के परिवार से व्यक्तिगत रूप से मिलने का प्रयास करते हैं।

हम उनके जीवन, संघर्ष, परिवार और देश के प्रति दिए गए अमूल्य योगदान की प्रेरणादायक कहानी को जनता तक पहुँचाते हैं, ताकि आने वाली पीढ़ियाँ हमारे वीरों के बलिदान और उनके परिवारों के योगदान को याद रख सकें।</p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">2. राजनीतिक मुद्दे और निष्पक्ष विश्लेषण</h2>
        <p>
         देश, प्रदेश और स्थानीय स्तर के राजनीतिक घटनाक्रम, चुनाव, प्रशासनिक नीतियों और जनहित से जुड़े राजनीतिक मुद्दों पर हमारी पैनी नज़र रहती है।

हमारा प्रयास है कि राजनीतिक खबरों को बिना किसी पक्षपात या दबाव के तथ्यों के आधार पर जनता के सामने प्रस्तुत किया जाए।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">3. कृषि, कीटनाशक और फंगीनाशक दवाइयों की जमीनी हकीकत</h2>
        <p>
         देश के अन्नदाता किसानों की समस्याओं और हितों को हम विशेष प्राथमिकता देते हैं।

कृषि में इस्तेमाल होने वाली कीटनाशक एवं फंगीनाशक दवाइयों से जुड़े मामलों की जमीनी पड़ताल करते हुए हम यह सामने लाने का प्रयास करेंगे कि बाजार में प्रतिबंधित या संदिग्ध दवाइयों की बिक्री तो नहीं हो रही है और किसानों को प्रमाणित कृषि उत्पाद समय पर उपलब्ध हो रहे हैं या नहीं।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">4. सरकारी योजनाएँ आम जनता तक</h2>
        <p>
          सरकार और प्रशासन द्वारा संचालित जनकल्याणकारी योजनाओं, नीतियों और विकास कार्यों की सही एवं उपयोगी जानकारी आम नागरिकों तक पहुँचाना हमारी प्रमुख जिम्मेदारियों में शामिल है।

हमारा प्रयास है कि जनता को योजनाओं के लाभ, पात्रता, प्रक्रिया और संबंधित महत्वपूर्ण जानकारी सरल भाषा में उपलब्ध हो। तथा शिक्षा प्रणाली बेहतर करने के सम्बन्ध में भी हम समय-समय पर रिपोर्टिंग करते हैं ताकि छात्रों और अभिभावकों को सही जानकारी मिल सके।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">5. जनता की आवाज़ सरकार तक</h2>
        <p>
        आम नागरिकों, किसानों, युवाओं, व्यापारियों और जरूरतमंद लोगों की समस्याओं, शिकायतों और सुझावों को प्रमुखता से उठाना हमारी पत्रकारिता का महत्वपूर्ण हिस्सा है।

हम जनता की समस्याओं को जिम्मेदार अधिकारियों और संबंधित विभागों तक पहुँचाने के लिए एक प्रभावी माध्यम के रूप में कार्य करने का प्रयास करते हैं।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">6. खाद्य एवं रसद विभाग</h2>
        <p>
        राशन वितरण प्रणाली, खाद्य सुरक्षा, सरकारी गोदामों, सार्वजनिक वितरण प्रणाली और खाद्य एवं रसद विभाग से जुड़े मामलों पर हमारी विशेष नज़र रहती है।

हमारा उद्देश्य है कि व्यवस्था में पारदर्शिता बनी रहे और आम जनता तक उसके अधिकारों से जुड़ी सही जानकारी पहुँचे।  
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">7. उद्योग और व्यापार</h2>
        <p>
         स्थानीय व्यापारियों, उद्यमियों, छोटे उद्योगों और व्यवसाय जगत से जुड़ी गतिविधियों एवं समस्याओं को भी हम प्रमुखता से कवर करते हैं।

हमारा प्रयास है कि स्थानीय अर्थव्यवस्था और रोजगार को प्रभावित करने वाले महत्वपूर्ण विषयों को जनता के सामने लाया जाए।
        </p>
      </section>
       <section className="about-section reveal card">
        <h2 className="section-heading">8. विशेष पॉडकास्ट और खोजपरक पत्रकारिता</h2>
        <p>
         सामाजिक, राजनीतिक, आर्थिक और जनहित से जुड़े महत्वपूर्ण मुद्दों पर विशेष पॉडकास्ट, ग्राउंड रिपोर्ट और संवाद के माध्यम से विभिन्न पहलुओं को जनता के सामने रखने का प्रयास किया जाता है। 
        </p>
      </section>

      <section className="about-section reveal founder-certificate-section">
        <div className="founder-left">
          <div className="founder-image-wrap">
            <img
              src={image4}
              alt="अधिवक्ता प्रीति चौधरी"
              className="founder-image"
              width="240"
              height="240"
            />
          </div>
          <div className="founder-text">
            <h3 className="founder-name">रिंकू चौधरी</h3>
            <p className="founder-title">संस्थापक – RR NEWS TV FASTEST UPDATE</p>
          </div>
        </div>

        <div className="founder-right">
          <div className="certificate-card">
            <img
              src={certificateImage}
              alt="RR NEWS TV FASTEST UPDATE प्रमाणपत्र"
              className="certificate-image"
              width="400"
              height="500"
            />
          </div>
        </div>
      </section>

      {/* Editors Section */}
      <section className="about-section reveal editors-section">
        <h2 className="section-heading">संपादकीय टीम (Editors)</h2>
        <div className="editors-grid">
          {editors.map((editor, index) => (
            <div key={index} className="editor-card">
              <div className="editor-image-wrapper">
                <img 
                  src={editor.image} 
                  alt={editor.name}
                  className="editor-image"
                  loading="lazy"
                  width="250"
                  height="250"
                />
              </div>
              <div className="editor-info">
                <h3 className="editor-name">{editor.name}</h3>
                <p className="editor-title">{editor.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Advocates Section with Images */}
      {/* <section className="about-section reveal advocates-section">
        <h2 className="section-heading">हमारी विधिक सलाहकार टीम</h2> */}
        
        {/* Top Row - With Images */}
        {/* <div className="advocates-grid-top">
          {advocatesTop.map((advocate, index) => (
            <div key={index} className="advocate-card-with-image">
              <div className="advocate-image-wrapper">
                <img 
                  src={advocate.image} 
                  alt={advocate.name}
                  className="advocate-image"
                  loading="lazy"
                  width="300"
                  height="300"
                />
              </div>
              <div className="advocate-info">
                <h3 className="advocate-name">{advocate.name}</h3>
                <p className="advocate-title">{advocate.title}</p>
              </div>
            </div>
          ))}
        </div> */}

        {/* Bottom Row - Black Cards */}
        {/* <div className="advocates-grid-bottom">
          {advocatesBottom.map((advocate, index) => (
            <div key={index} className="advocate-card-black">
              <div className="black-card-content">
                <h3 className="advocate-name-black">{advocate.name}</h3>
                <p className="advocate-title-black">{advocate.title}</p>
              </div>
            </div>
          ))}
        </div> */}
      {/* </section> */}

      <section className="about-section reveal card">
        <h2 className="section-heading">हम क्या कवरेज करते हैं</h2>
        <ul className="coverage-list">
          <li>सम्पूर्ण भारत की ताज़ा खबरें — घटनाएँ, प्रशासनिक समाचार और नागरिक समस्याएँ।</li>
          <li>समस्त राज्यों से क्षेत्रीय रिपोर्टें और अपडेट।</li>
          <li>कृषि एवं किसान मुद्दे — खेती, कृषि उत्पाद, कीटनाशक, फंगीनाशक और किसानों की समस्याएँ।</li>
          <li>शिक्षा एवं रोजगार — स्कूल, कॉलेज, प्रतियोगी परीक्षाएँ, रोजगार और युवाओं से जुड़े मुद्दे।</li>
          <li>स्वास्थ्य — स्वास्थ्य सेवाएँ, अस्पताल और जनस्वास्थ्य से संबंधित महत्वपूर्ण खबरें।</li>
          <li>अपराध एवं कानून-व्यवस्था — स्थानीय घटनाएँ और प्रशासनिक कार्रवाई।</li>
          <li>उद्योग एवं व्यापार — व्यापारी, बाजार, उद्योग और स्थानीय अर्थव्यवस्था।</li>
          <li>स्थानीय जीवन एवं संस्कृति — त्योहार, लोककला, सामाजिक कार्यक्रम और सांस्कृतिक गतिविधियाँ।</li>
          <li>विशेष रिपोर्ट एवं ग्राउंड रिपोर्ट — जमीनी स्तर पर जाकर महत्वपूर्ण मुद्दों की पड़ताल।</li>
          <li>विशेष पॉडकास्ट — सामाजिक और राजनीतिक विषयों पर विशेष संवाद एवं चर्चा।</li>

        </ul>
      </section>

      <section className="about-section reveal card">
        <h2 className="section-heading">हमारे पाठक-सदस्य और समुदाय</h2>
        <p>
         हमारे लिए हमारे पाठक केवल समाचार पढ़ने वाले लोग नहीं, बल्कि हमारे समाचार समुदाय के सहभागी हैं।

स्थानीय खबरों, सुझावों, तस्वीरों और जनसमस्याओं को हमारे साथ साझा करके आप भी जिम्मेदार पत्रकारिता में योगदान दे सकते हैं।

यदि आपके क्षेत्र में कोई महत्वपूर्ण घटना, जनसमस्या, सामाजिक पहल या जनहित से जुड़ा विषय है, तो आप हमें इसकी जानकारी भेज सकते हैं। आपकी जानकारी किसी महत्वपूर्ण मुद्दे को समाज और प्रशासन के सामने लाने में मदद कर सकती है।
        </p>
      </section>

      <section className="about-section reveal card">
        <h2 className="section-heading">संस्थापक का संदेश</h2>
        <p>
          प्रिय पाठकों,
संविधान ने मीडिया को लोकतंत्र के 'चौथे स्तंभ' की जो जिम्मेदारी सौंपी है, उसका वास्तविक अर्थ समाज में सकारात्मक बदलाव लाना और जन-जन की आवाज बनना है। आज के समय में जब सूचनाओं का अंबार है, तब यह अत्यंत आवश्यक है कि देश के हर कोने—गाँव से लेकर महानगरों तक—की सच्ची, निष्पक्ष और सटीक खबरें बिना किसी दबाव के जनता के सामने आएं।
RR News TV (RR News Fastest Update) का उद्देश्य सिर्फ खबरें परोसना नहीं है, बल्कि संपूर्ण भारत की जमीनी हकीकत को निष्पक्षता के साथ उजागर करना है। हम मानते हैं कि समाज में वास्तविक बदलाव केवल जिम्मेदार और निडर पत्रकारिता के माध्यम से ही संभव है।
हमारा यह संकल्प है कि हम राष्ट्र निर्माण, किसानों के अधिकारों, शहीद परिवारों के सम्मान और आम आदमी की हर समस्या को पूरी ईमानदारी के साथ प्रमुखता से उठाएंगे। देश के विकास में एक जागरूक नागरिक की भूमिका सबसे अहम होती है, और इस सफर में आपका विश्वास हमारी सबसे बड़ी ताकत है। आइए, मिलकर एक सशक्त और जागरूक समाज का निर्माण करें।
जय हिंद, जय भारत!
— रिंकू चौधरी
(संपादक / संस्थापक, RR News TV)
        </p>
      </section>

      <section className="about-section reveal card">
        <h2 className="section-heading">हमारी नीतियाँ (संक्षेप में)</h2>
        <ul>
          <li><strong>निष्पक्षता और सचाई:</strong> खबरों में तथ्यों की पुष्टि करके प्रकाशित किया जाता है।</li>
          <li><strong>पारदर्शिता:</strong> त्रुटि होने पर सुधार और स्पष्टीकरण दिया जाएगा।</li>
          <li><strong>पाठक-हमारी प्राथमिकता:</strong> पाठक की गोपनीयता व सुरक्षा का सम्मान किया जाता है।</li>
        </ul>
      </section>

      <section className="about-section reveal contact-card">
        <h2 className="section-heading">ई-पेपर और सदस्यता</h2>
        <p>
          WORK IN PROGRESS: ई-पेपर और सदस्यता सुविधा जल्द ही उपलब्ध होगी। इस सुविधा के माध्यम से आप RR NEWS TV FASTEST UPDATE की ताज़ा खबरों, विशेष रिपोर्टों और पॉडकास्ट को सीधे अपने ईमेल या मोबाइल पर प्राप्त कर सकेंगे।
        </p>
        <div className="about-ctas">
          <a className="btn primary" href="mailto:support@moradabadujala.in">ईमेल: rrofficial893@gmail.com</a>
          <a className="btn" href="tel:+91-5921354286">फोन/व्हाट्सएप: +91-8979916908</a>
        </div>
      </section>

      <footer className="about-footer reveal">
        <p>RR NEWS TV FASTEST UPDATE में आपका स्वागत है — पढ़ें, साझा करें, और अपने समुदाय की आवाज़ बनें।</p>
        <div className="about-actions">
          <a className="btn accent" href="/contact">संपर्क करें</a>
          <a className="btn" href="#">ई-पेपर / सदस्यता</a>
        </div>
      </footer>
    </main>
  </>
  );
}

export default AboutPage;


